import { Button } from "@/components/ui/button";
import { Home, Compass, Gamepad2, ShieldQuestion } from "lucide-react";
import { useLocation } from "wouter";
import { motion } from "framer-motion";

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-background p-4 text-center overflow-hidden">
        <motion.div 
            initial={{ scale: 0.5, opacity: 0, rotate: -30 }}
            animate={{ scale: 1, opacity: 1, rotate: 0 }}
            transition={{ type: 'spring', stiffness: 100, damping: 10, delay: 0.1 }}
            className="relative mb-8"
        >
            <ShieldQuestion className="h-48 w-48 text-primary/10" />
            <motion.p 
                className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-7xl font-bold text-primary-foreground"
                initial={{ opacity: 0, scale: 0.5 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.4 }}
            >
                404
            </motion.p>
        </motion.div>

        <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            className="text-4xl font-bold mb-4"
        >
            Lost in the Game?
        </motion.h1>

        <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8 }}
            className="text-muted-foreground max-w-md mb-8"
        >
            It seems you've wandered off the map. The page you're looking for doesn't exist or has been moved to another castle.
        </motion.p>

        <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.0 }}
            className="flex flex-col sm:flex-row gap-4"
        >
            <Button onClick={() => setLocation("/")} size="lg" className="glow-effect">
                <Home className="mr-2 h-5 w-5" />
                Return to Home Base
            </Button>
            <Button onClick={() => setLocation("/earn")} size="lg" variant="outline">
                <Gamepad2 className="mr-2 h-5 w-5" />
                Explore Earning Areas
            </Button>
        </motion.div>
    </div>
  );
}
